module.exports = __webpack_public_path__ + "static/img/A6408_1.a8cc09dc.png";